module.exports = __webpack_public_path__ + "img/jialu.90cd9f66.png";